<template>
  <div class="feedback">
    <feedback-add :contract_id="contract_id" />
    <feedback-list :contract_id="contract_id" />
  </div>
</template>

<script>
import FeedbackAdd from './feedback-add'
import FeedbackList from './feedback-list'

export default {
  props: {
    contract_id: {
      type: String
    }
  },
  components: {
    FeedbackAdd,
    FeedbackList
  }
}
</script>

<style>

</style>
